// import {
//     applyMiddleware,
//     combineReducers,
//     compose
// } from 'redux';
// import createSagaMiddleware from 'redux-saga';
// import { LabelGridReducer } from './reducer';
// import { watchLabelGridList } from './saga';
// import { configureStore } from '@reduxjs/toolkit';

// const sagaMiddleware = createSagaMiddleware();
// const middleware = applyMiddleware(sagaMiddleware);

// const composeEnhancers =
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const reducers = combineReducers({
//     labelLayoutGridList: LabelGridReducer,
// });

// export const store = configureStore({reducer: reducers}, composeEnhancers(middleware));
// console.log(middleware);

// middleware.run(watchLabelGridList);   

import {
    applyMiddleware,
    combineReducers,
    createStore,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import { LabelGridReducer } from './reducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    labelLayoutGridList: LabelGridReducer,

});

export const store = createStore(reducers, composeEnhancers(middleware));